<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <VaAvatar :size="32" color="warning"> &#x1F464; </VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList>
          <header class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">
            <!--            {{ t(`user.${group.name}`) }}-->
            {{ loggedInUser?.replace('%40', '@') }}
          </header>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="logout">
            <VaIcon name="mso-logout" class="pr-1" color="secondary" />
            Logout
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
// import { useI18n } from 'vue-i18n'
import { useColors, useToast } from 'vuestic-ui'
const { init } = useToast()
import { getData } from '../../../../services/utils'
import api from '../../../../services/api'
import { useRouter, useRoute } from 'vue-router'

const { push } = useRouter();
const route = useRoute();


const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

// const { t } = useI18n()

// type ProfileListItem = {
//   name: string
//   to?: string
//   href?: string
//   icon: string
// }

// type ProfileOptions = {
//   name: string
//   separator: boolean
//   list: ProfileListItem[]
// }

const isShown = ref(false)

const logout = async () => {
  try {
    await getData(api.logout())

    init({
      message: "You've successfully logged out",
      color: 'success',
    })

    setTimeout(() => {
      push({
        name: 'login',
        query: {
            redirect: route.fullPath
        }
      })
    }, 1000)
  } catch (e: any) {
    console.error(e)
    init({
      message: `Could not log you out.<br>If problem continues, contact support.`,
      color: 'danger',
      dangerouslyUseHtmlString: true,
      // duration: 0,
    })
  }
}

import { getCookie } from '@/services/utils';
const loggedInUser = getCookie('bragg_lobby_user');
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
